/**
 * ErrorList  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { FC, useCallback } from "react";
import { BEM } from "@adapptio/lib-components";
import { Icon, ICON_SIZE } from "../Icon";

export interface IItemListRowProps<RowData> {
	rowData?: RowData;
	icon?: string;
	className?: string;
	onClick?: (rowData?: RowData) => void;
}

export const ItemListRow: FC<IItemListRowProps<unknown>> = ({
	rowData,
	icon,
	className,
	onClick,
	children
}) => {
	const onClickHandler = useCallback(() => {
		if (onClick) {
			onClick(rowData);
		}
	}, [rowData, onClick]);

	const baseClass = BEM("edt-item-list", "row", {
		"is-active": !!onClick,
		"has-icon": !!icon,
	});

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()} onClick={onClickHandler}>
			{ icon && <Icon name={icon} size={ICON_SIZE.XSMALL} />}
			<div className={baseClass.element("row-content").toClassName()}>
				{children}
			</div>
		</div>
	);
};
